import { existsSync, mkdirSync, WriteFileOptions } from 'fs';
import { dirname, extname, join, resolve } from 'path';

/**
 * returns the closest entry dir for the given path,
 * including the given path.
 * @param startPath
 * @returns
 */
export const getClosestPackageDir = (startPath?: string) => {
  /* istanbul ignore if */
  let mainFileName = startPath;

  /* istanbul ignore else */
  if (!startPath) {
    mainFileName = process.cwd();
  }

  let currentPath: string = mainFileName;
  let result = '';

  while (currentPath && currentPath !== '/') {
    if (existsSync(join(currentPath, 'package.json'))) {
      result = currentPath;
      break;
    }
    currentPath = resolve(currentPath, '../');
  }
  return result;
};

/**
 * synchronously creates the directory if it does not exist
 * @param dirPath - directory or file path.
 */
export const mkDirSync = (dirPath: string): void => {
  const extName = extname(dirPath);
  dirPath = extName !== '' ? dirname(dirPath) : dirPath;
  if (!existsSync(dirPath)) {
    let existingPath = '';
    let current = dirPath;
    while (existingPath === '' && current !== '/' && current !== '') {
      current = join(current, '../');
      if (existsSync(current)) {
        existingPath = current;
      }
    }

    dirPath
      .split(existingPath)[1]
      .split('/')
      .forEach((pathToken) => {
        existingPath = join(existingPath, pathToken);
        mkdirSync(existingPath);
      });
  }
};

/**
 * synchronously writes the given data to the given path
 */
export const writeFileSync = (
  filePath: string,
  data: any,
  options?: WriteFileOptions
): void => {
  mkDirSync(filePath);
  writeFileSync(filePath, data, options);
};

/**
 * returns true if running in production environment
 */
export const isProdEnv = (): boolean => {
  return (
    process.env.NODE_ENV &&
    process.env.NODE_ENV.toLowerCase().indexOf('prod') === 0
  );
};

/**
 * returns true if running in test environment
 */
export const isTestEnv = (): boolean => {
  return (
    process.env.NODE_ENV &&
    process.env.NODE_ENV.toLowerCase().indexOf('test') === 0
  );
};

/**
 * returns true if app is not running in production environment
 */
export const isDevEnv = (): boolean => {
  return !isProdEnv();
};
